import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import stripe1 from './pictures/stripe1.jpg';
import stripe2 from './pictures/stripe2.jpg';
import stripe3 from './pictures/stripe3.jpg';

const Stripe = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Open Networking & Lunch with Stripe!</h2>
                    <p class="site-post-meta">November 6th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On Thursday, November 7th, WiC hosted our Lunch & Networking with Stripe event! We had the opportunity to connect with the amazing Stripe team and hear from them about their unique career paths. Attendees got the chance to ask questions to a panel, receive valuable recruiting insights, and enjoy some great food. Thank you to everyone who joined us!
                    </p>
                    <img src={stripe1} alt="pic1 "/>
                    <img src={stripe2} alt="pic2"/>
                    <img src={stripe3} alt="pic3"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Stripe;
